/**
 * @desc 根据Area编码查询Provinces信息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.RegionEncodingParameters): Promise<BaseResponse<defs.ResultBean<defs.Provinces>>> {
  return fetch({
    url: config.API_HOST + '/dict/findProCityRegionByRegion',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
